"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterviewsPage = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const InterviewsCreateLink_1 = __importDefault(require("../interviews/InterviewsCreateLink"));
const InterviewsPage = (props) => {
    const location = (0, react_router_1.useLocation)();
    const urlSearch = new URLSearchParams(location.search);
    return (react_1.default.createElement("div", { className: "admin" },
        react_1.default.createElement("div", { className: "survey-section__content apptr__form-container" },
            react_1.default.createElement("h1", null, props.t('admin:interviewers:InterviewsSearchAndEdit')),
            react_1.default.createElement(react_router_1.Link, { to: '/interviews/byCode' }, props.t('admin:interviewSearch:SearchByCode')),
            react_1.default.createElement(InterviewsCreateLink_1.default, { queryData: urlSearch }))));
};
exports.InterviewsPage = InterviewsPage;
exports.default = (0, react_i18next_1.withTranslation)(['admin'])(exports.InterviewsPage);
//# sourceMappingURL=InterviewsPage.js.map